import * as React from 'react';

import { DixaMessengerApiV2 } from 'components/settings/components/sections/dixaMessenger/api/dixaMessengersApi';

export const dixaMessengerApi = new DixaMessengerApiV2();
const DixaMessengerApiContext = React.createContext(dixaMessengerApi);

export function useDixaMessengerApi(): DixaMessengerApiV2 {
  const api = React.useContext(DixaMessengerApiContext);
  return api;
}

export function DixaMessengerApiProvider({
  children,
}: React.PropsWithChildren<Record<string, unknown>>): JSX.Element {
  return (
    <DixaMessengerApiContext.Provider value={dixaMessengerApi}>
      {children}
    </DixaMessengerApiContext.Provider>
  );
}
